module.exports = __webpack_public_path__ + "img/payfort.dc883831.png";